import { MetricsMenuApp } from './MetricsMenuApp';
import { registerReactWebComponent, parseListAttribute } from '@/core/utils/webComponent';

const getCombinedValue = (element, params, attr, camelParam) =>
  element.getAttribute(attr) || params.get(camelParam) || params.get(attr);

const getStringProp = (element, params, attr, camelParam) =>
  getCombinedValue(element, params, attr, camelParam) || undefined;

const getListValue = (element, params, attr, camelParam) =>
  parseListAttribute(getCombinedValue(element, params, attr, camelParam));

const extractMetricsMenuProps = (element) => {
  const params = new URLSearchParams(globalThis.location?.search || '');

  return {
    selectedChannel: getStringProp(element, params, 'selected-channel', 'selectedChannel'),
    pageId: getStringProp(element, params, 'page-id', 'pageId'),
    channelExternalUrl: getStringProp(element, params, 'channel-external-url', 'channelExternalUrl'),
    pages: getListValue(element, params, 'pages', 'pages'),
    accountName: getStringProp(element, params, 'account-name', 'accountName'),
    profileImage: getStringProp(element, params, 'profile-image', 'profileImage'),
    searchOptions: getListValue(element, params, 'search-options', 'searchOptions'),
    selectedSearch: getStringProp(element, params, 'selected-search', 'selectedSearch'),
    universeId: getStringProp(element, params, 'universe-id', 'universeId'),
    disabledItemIds: getListValue(element, params, 'disabled-items', 'disabled-items'),
  };
};

export const registerMetricsMenuComponent = () => {
  registerReactWebComponent('content-metrics-menu', MetricsMenuApp, extractMetricsMenuProps);
};
